import prePopulateForm from 'root/src/client/logic/form/actions/prePopulateForm'
import { ADD_DROP_EVENT_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { ADD_DROP_EVENT_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

export default item => (dispatch) => {
	dispatch(prePopulateForm({
		moduleKey: `${ADD_DROP_EVENT_ROUTE_ID}-${ADD_DROP_EVENT_FORM_MODULE_ID}`,
		formData: item,
		scrollTop: true,
	}))
	return pushRouteClient({ routeId: ADD_DROP_EVENT_ROUTE_ID })
}
